import {
  LOAD_STOCK_BALANCE,
  LOAD_STOCK_BALANCE_IS_DIRTY,
  EXPORT_STOCKE_BALANCE,
  CREAT_STOCK_BALANCE,
  CREAT_STOCK_BALANCE_FROM_IS_DIRTY,
  LOAD_STOCK_BALANCE_DETAIL,
  LOAD_STOCK_BALANCE_DETAIL_IS_DIRTY,
  UPDATE_STOCK_BALANCE,
  REMOVE_LISTS,
} from "./actions";

const initialState = {
  lists: [],
  detial: null,
  total: 1,
  loading: false,
  draw: -1,
  check: true,

  stock_balance_is_dirty_loading: false,
  stock_balance_is_dirty_lists: [],
  stock_balance_is_dirty_detial: null,
  stock_balance_is_dirty_total: 1,
  stock_balance_is_dirty_draw: -1,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case REMOVE_LISTS:
      return initialState;

    case LOAD_STOCK_BALANCE.REQUEST:
      const { loading } = action.payload.data;
      return {
        ...state,
        loading: loading,
      };

    case LOAD_STOCK_BALANCE.SUCCESS:
      return {
        ...state,
        lists: action.payload.lists.data,
        total:
          action.payload.lists.total - 1 <= 0
            ? 1
            : action.payload.lists.total <= 0
            ? 1
            : action.payload.lists.total,
        loading: false,
        draw: Math.floor(Math.random() * 999 + 1),
      };

    case LOAD_STOCK_BALANCE_IS_DIRTY.REQUEST:
      const { stock_balance_is_dirty_loading } = action.payload;
      return {
        ...state,
        stock_balance_is_dirty_loading: stock_balance_is_dirty_loading,
      };

    case LOAD_STOCK_BALANCE_IS_DIRTY.SUCCESS:
      return {
        ...state,
        stock_balance_is_dirty_lists:
          action.payload.stock_balance_is_dirty_lists.data,
        stock_balance_is_dirty_total:
          action.payload.stock_balance_is_dirty_lists.total - 1 <= 0
            ? 1
            : action.payload.stock_balance_is_dirty_lists.total <= 0
            ? 1
            : action.payload.stock_balance_is_dirty_lists.total,
        stock_balance_is_dirty_loading: false,
        stock_balance_is_dirty_draw: Math.floor(Math.random() * 999 + 1),
      };

    case EXPORT_STOCKE_BALANCE.REQUEST:
      return {
        ...state,
        loading: true,
      };

    case EXPORT_STOCKE_BALANCE.SUCCESS:
      return {
        ...state,
        loading: false,
      };

    case CREAT_STOCK_BALANCE.REQUEST:
      return {
        ...state,
        loading: true,
      };

    case CREAT_STOCK_BALANCE.SUCCESS:
      return {
        ...state,
        loading: false,
      };

    case CREAT_STOCK_BALANCE_FROM_IS_DIRTY.REQUEST:
      return {
        ...state,
        stock_balance_is_dirty_loading: true,
      };

    case CREAT_STOCK_BALANCE_FROM_IS_DIRTY.SUCCESS:
      return {
        ...state,
        stock_balance_is_dirty_loading: false,
      };

    case LOAD_STOCK_BALANCE_DETAIL.REQUEST:
      return {
        ...state,
        detial: null,
        loading: true,
      };

    case LOAD_STOCK_BALANCE_DETAIL.SUCCESS:
      return {
        ...state,
        detial: action.payload.lists.data,
        loading: false,
      };

    case LOAD_STOCK_BALANCE_DETAIL_IS_DIRTY.REQUEST:
      return {
        ...state,
        stock_balance_is_dirty_detial: null,
        stock_balance_is_dirty_loading: true,
      };

    case LOAD_STOCK_BALANCE_DETAIL_IS_DIRTY.SUCCESS:
      return {
        ...state,
        stock_balance_is_dirty_detial: action.payload.lists,
        stock_balance_is_dirty_loading: false,
      };

    case UPDATE_STOCK_BALANCE.REQUEST:
      return {
        ...state,
        loading: true,
      };

    case UPDATE_STOCK_BALANCE.SUCCESS:
      return {
        ...state,
        loading: false,
      };

    default:
      return state;
  }
};
